import { useEffect, useState } from "react";
import { Marker, Tooltip, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from 'leaflet';
import { useDispatch, useSelector } from "react-redux";
import '../../styles/Pillars04.css'
import { getIconMarkerCluster } from "./helper";
import MarkerClusterGroup from "react-leaflet-markercluster";
import { zLayers } from "./ControlLayer";
import { useCallback } from "react";



export const LayerPillarsRunn = props => {
    // console.log('LayerPillars04')
    const map = useMap()
    const [mapState, setMapState] = useState({ zoom: map.getZoom(), bounds: map.getBounds() });

    // Подписываемся на события карты для обновления при перемещении/зуме
    useEffect(() => {
        const handleMapChange = () => {
            setMapState({ zoom: map.getZoom(), bounds: map.getBounds() });
        };

        map.on('zoomend', handleMapChange);
        map.on('moveend', handleMapChange);

        return () => {
            map.off('zoomend', handleMapChange);
            map.off('moveend', handleMapChange);
        };
    }, [map]);


    const handleMarkerClick = useCallback((mark) => (e) => {
        map.fire('openPopup', {
            class: 'pillar',
            mark: mark,
        });
    }, [map]);

    // const [openedPopup, setOpenedPopup] = useState(null)
    const { pillarsRunn } = useSelector(
        (state) => state.state.electricityFiltered
    );

    const { printing, drawing } = useSelector(
        (state) => state.helper
    );

    if (!pillarsRunn) {
        return <></>
    }





    //для усечения маркеров находящихся в невидимой области
    const bounds = printing ? new L.LatLngBounds([printing.bounds.south, printing.bounds.west], [printing.bounds.north, printing.bounds.east]) : mapState.bounds
    const nePixel = map.project(bounds.getNorthEast());
    const swPixel = map.project(bounds.getSouthWest());

    //для позиционирования надписей
    // const posBounds = printing && printing.posBounds ? new L.LatLngBounds([printing.posBounds.south, printing.posBounds.west], [printing.posBounds.north, printing.posBounds.east]) : map.getBounds()
    const posBounds = mapState.bounds

    const posnePixel = map.project(posBounds.getNorthEast());
    const posswPixel = map.project(posBounds.getSouthWest());


    let hosts = pillarsRunn
    hosts = hosts.map((mark, index) => {



        const markPixel = map.project(mark.coords)
        // if (!mark.accounting) return null

        //Отбрасываем маркеры которые выходят за рамки видимой области
        if ((markPixel.x < swPixel.x) || (markPixel.x > nePixel.x) || (markPixel.y < nePixel.y) || (markPixel.y > swPixel.y)) return null
        //Если идет печать то отбрасываем маркеры которые выходят за рамки заданной области
        if (printing) {
            if ((markPixel.x < posswPixel.x) || (markPixel.x > posnePixel.x) || (markPixel.y < posnePixel.y) || (markPixel.y > posswPixel.y)) return null
        }

        return mark



    }).filter(f => f)





    const markers = hosts.map((mark, index) => {
        const mount_status =  props.viewMounted ? mark.mount_status : 0
        return (
            <Marker
                position={mark.coords}
                icon={L.divIcon({
                    className: 'pillars-runn-marker',
                    html: `<div>
                    ${mount_status > 0 ?
                        `
                        <div style='position:absolute; bottom: 0; display:flex; margin-left: -7px; margin-bottom: -7px'>
                            <svg width="36" height="36" viewBox="0 0 100 100">
                                <defs>
                                <radialGradient id="OpnRadialGradient1">
                                    <stop offset="0%" stop-color="#ffa000" stop-opacity="0" />
                                    <stop offset="10%" stop-color="#ffa000" stop-opacity="0" />
                                    <stop offset="70%" stop-color="#ffa000" stop-opacity="0.7" />
                                    <stop offset="100%" stop-color="#ffa000" stop-opacity="0" />
                                </radialGradient>
                                <radialGradient id="OpnRadialGradient2">
                                    <stop offset="0%" stop-color="#00dd00" stop-opacity="0" />
                                    <stop offset="10%" stop-color="#00dd00" stop-opacity="0" />
                                    <stop offset="70%" stop-color="#00dd00" stop-opacity="0.7" />
                                    <stop offset="100%" stop-color="#00dd00" stop-opacity="0" />
                                </radialGradient>
                                <radialGradient id="OpnRadialGradient3">
                                    <stop offset="0%" stop-color="#dd50dd" stop-opacity="0" />
                                    <stop offset="10%" stop-color="#dd50dd" stop-opacity="0" />
                                    <stop offset="70%" stop-color="#dd50dd" stop-opacity="0.7" />
                                    <stop offset="100%" stop-color="#dd50dd" stop-opacity="0" />
                                </radialGradient>
                                <radialGradient id="OpnRadialGradient4">
                                    <stop offset="0%" stop-color="#8b008b" stop-opacity="0" />
                                    <stop offset="10%" stop-color="#8b008b" stop-opacity="0" />
                                    <stop offset="70%" stop-color="#8b008b" stop-opacity="0.7" />
                                    <stop offset="100%" stop-color="#8b008b" stop-opacity="0" />
                                </radialGradient>
                                </defs>
                                <circle r="50" cx="50" cy="50" fill="url(#OpnRadialGradient${mount_status})" />
                            </svg>
                        </div>
                        ` : ''
                        }
                    <div style='position:absolute; top: 0; display:flex; margin-left: 0px; margin-bottom: 0px'>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="24" height="24">
                            <!-- Корпус щита -->
                            <rect x="16" y="12" width="32" height="40" rx="4" fill="none" stroke="red" stroke-width="5" stroke-linecap="round"/>

                            <!-- Широкая красная молния -->
                            <polyline points="32,20 26,32 38,32 30,44" 
                                        fill="none" 
                                        stroke="red" 
                                        stroke-width="5" 
                                        stroke-linecap="round" 
                                        stroke-linejoin="round"/>
                            </svg>
                        </div>
                    </div>`,
                    iconSize: [24, 24],
                    iconAnchor: [12, 12]


                })}
                key={printing ? `printing_runn_${mark.fid}` : drawing ? `drawing_runn_${mark.fid}` : `runn_${mark.fid}`}
                data={mark.fid}
                type={mark.type}
                pane="otherPane"
                interactive={!drawing?.state}
                spec={mark.spec}
                eventHandlers={{
                    click: handleMarkerClick(mark)
                }}
            // eventHandlers={{
            //     click: (e) => {
            //         map.fire('openPopup', {
            //             class: 'pillar',
            //             mark: mark
            //         })

            //     }
            // }}







            >

                {!drawing &&
                    <Tooltip
                        direction="top"
                        key={`${mark.fid}_tooltip`}
                        offset={[2, -6]}
                        opacity={1}

                    >
                        РУНН
                    </Tooltip>
                }



            </Marker>



        );
    }).filter(Boolean);

    const createClusterCustomIcon = (cluster) => {
        let type = 'pillarRunn'

        return getIconMarkerCluster(cluster.getAllChildMarkers().length, type)
    };


    return <MarkerClusterGroup
        // key={Date.now()}
        maxClusterRadius={40}
        iconCreateFunction={createClusterCustomIcon}
        removeOutsideVisibleBounds
        zoomToBoundsOnClick={true}
        spiderfyOnEveryZoom={false}
        // animateAddingMarkers
        // animate
        type={'cluster'}
        clusterPane="otherPane"
        chunkedLoading={true}
        disableClusteringAtZoom={18}
        polygonOptions={{ color: "#grey", weight: 1 }}



    >
        {markers}
    </MarkerClusterGroup>

    return markers;



}

